
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { ClientBalanceInfo } from '../../presentation/redux/states/SaleState';
import { CurrencyUtils } from '../../common/CurrencyUtils';
import { Loader } from './utils/Loader';

export const SkuClientBalance = ({ web_label }: any) => {
  const { clientBalance }: { clientBalance: ClientBalanceInfo } = useSelector((s: RootState) => s.saleState);
  const state = useSelector((s: RootState) => s.saleState);

  //[Balance Step 13]: Componente que muestra el webvalue o el balance en caso de que exista

  return (
    <>
      <div className="text-center my-3 ml-4 mr-4">
        {(!state.loadingBalance && clientBalance.web_label) ? (
          <div className="balance-highlight">
            <div className="balance-label">
              {clientBalance.web_label}
            </div>
            {clientBalance.web_value &&
              <div className="balance-value">
                {CurrencyUtils.moneyFormat(Number(clientBalance.web_value))}
              </div>
            }
          </div>
        ) : (
          <div className="balance-highlight">
            <div className="balance-label">{web_label}</div>
            <Loader />
          </div>
        )}
      </div>
    </>

  )
}

SkuClientBalance.propTypes = {
  web_label: PropTypes.string.isRequired,
}